import angular from 'angular';
import errorsLegendComponent from './errorsLegend.component';

let errorsLegendModule = angular.module('errorsLegend', []).component('errorsLegend', errorsLegendComponent);

export default errorsLegendModule;



// WEBPACK FOOTER //
// ./app/common/errorsLegend/errorsLegend.js